package com.willandsons.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLovenearbyTermsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("LovenearbyTerms.md", FrontMatterElement.Builder { addScalar("title", "Terms and Conditions"); }))
}

@Page("/lovenearby-terms")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun LovenearbyTermsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("terms-and-conditions") }) {
        org.jetbrains.compose.web.dom.Text("TERMS AND CONDITIONS")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("USER AGREEMENT for using the LoveNearby app")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Please read this Agreement carefully before you create an account. It sets out the terms and conditions under which we provide you with our services through the LoveNearby app. By accessing or using the LoveNearby app’s services, you agree to be bound by this User Agreement, including our ")
            com.varabyte.kobweb.silk.components.navigation.Link("/privacy-policy") {
                org.jetbrains.compose.web.dom.Text("Privacy Policy")
            }
            org.jetbrains.compose.web.dom.Text(" and ")
            com.varabyte.kobweb.silk.components.navigation.Link("/lovenearby-safety") {
                org.jetbrains.compose.web.dom.Text("Safety Advice")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("We may update these Terms from time to time without notifications so please check this page periodically for updates. By continue using the LoveNearby app constitutes your consent to any changes.")
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("THE PARTIES:")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The LoveNearby app, named from now the APP, is developed and owned by WILLANDSONS SERVICES SRL, located in Romania, Targu Mures city, Parangului street no:56/37.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("This Terms of Use Agreement is made between WILLANDSONS SERVICES SRL, named Owner from now and any person, named User from now, who is a user of the LoveNearby app. This Agreement has a value of a legal contract between the parties.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("GOVERNING LEGISLATION")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Any legal issues arising between the parties will be resolved amicably. If this is not possible, the parties will address to the Mures County Court, Romania.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("USER’S OBLIGATIONS when creating an account on LoveNearby app")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you've read and agreed to our Terms and Conditions")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you are a person who is at least 18 years old")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you are creating an account under your own name, not in the name of another person, business or entity. Even if you can choose to use a Nickname instead of your real name, you have to provide an existing email, in order for us to communicate with you. You are fully responsible if the email is wrong and you can lose your account or/and your money(Premium  membership) because we cannot communicate raised issues with you. The Owner is NOT responsible for such account or money losses for this reason.")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you are not restricted by the law to enter into a binding contract with the Owner")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you have to comply with all applicable laws, including, but not limited to, privacy laws, intellectual property laws, anti-spam laws, financial laws, etc.")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you are not required to register as a sex offender")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you don’t have more than one account on LoveNearby app")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("you have not previously been removed from our APP by us, unless you have our express written permission to create a new account.")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("only you are responsible for the safety of your login credentials. If you can’t access you APP account because you forget the credentials or you are a victim of a fraud, the Owner can request additional data and documents in order to restore your account (for example an official ID, bank account number from where Premium membership was purchased, etc.)")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("You acknowledge that your profile is visible to other people around the world, so only post information that you feel you want to share with others. You acknowledge and agree that your content may be viewed by other users, and notwithstanding these Terms, other Users may forward your content to third parties. By uploading your content, you represent and warrant to the Owner that you have all necessary rights and permissions to do so, and you thereby automatically grant us permission to use your content. You understand and agree that we may monitor or review your content, and we have the right to remove, delete or to block or prevent access to any of your content at any time in our sole discretion. In addition, you understand and agree that we have no obligation to display or review your or other User’s content.")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("User’s must respect the following ONLINE GUIDELINES:")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("a) You are solely and directly responsible for the content of the information entered on the APP or sent to other Users")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("b) You shall not post on the App, nor transmit to other Users materials and/or messages that are obscene, offensive, aggressive, discriminatory, defamatory, threatening, blasphemous, illegal, sexual in nature, or any other materials and/or messages that violate the rights of the parties involved in any way. Sexual materials are understood to mean any type of content of a sexual nature, threats to distribute intimate images, as well as the offering of services of a sexual nature. Offers of services of a sexual nature include prostitution, escort services, sexual massages, and other sexual activities. When necessary, we make this content available to law enforcement agencies.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("c) You will not repeatedly send unwanted messages to other Users.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("d) You will not include obscene information in your profile.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("e) You will not include in your profile phone numbers, addresses, last names, email addresses, or any kind of confidential information about you, or related to other people.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("f) You will not upload photos to the APP that contain nudity, confidential information, or are copyrighted or other confidential information without the prior consent of the owner. The Customer Support team reserves the right to reject any photo that does not comply with these restrictions.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("g) You will not use the APP to advertise for the purpose of buying or selling products, pyramidal schemes, loan money, share political campaigns or for any other purposes")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("h) You will not collect or retain information about other Users, regardless of the purpose, without their prior consent.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("i) You may not modify, copy, translate, sell, or adapt any material or part of this App, regardless of the intended purpose.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("j) You are solely responsible for your relationships with other Users. The Customer Support Team reserves the right, but is not obliged, to monitor any disputes between Users, in situations where there is a legal obligation to do so or if a User reports abuse.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("k) You may not submit an inaccurate, misleading, or otherwise manifestly unfounded report of a member's conduct or content, or misuse any of the APP’s available reporting or appeal systems.")
                    }
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("l) for combating OCSEA (Online Child Sexual Exploitation and Abuse): It is prohibited to use materials that depicts or resembles a minor who is not accompanied by his or her parent or guardian or is not fully clothed, or that otherwise depicts or implies a minor engaging in sexual activity. If anything like this is detected by The Customer Support Team or been reported by other Users, the Owner will automatically send a report of the case to legal authorities, without any warnings. After that the account will be deleted without the right of any refund or to create a new account on the APP.")
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("OBJECT OF THE AGREEMENT - THE SERVICE")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Owner makes the APP available to Users for the purpose of meeting and communicating with other Users, while they respect the User Agreement.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("PRICING")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The APP can be downloaded and used for free, but this version contains advertising. You acknowledge that the Owner does not endorse and is not responsible for your interactions with these products or services provided by advertisers.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("You can remove ads and gain access to certain features with Premium Memberships.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The price for Premium Memberships can be changed at any time by the Owner, without any notification.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Purchased Premium Memberships will maintain their price and terms, even if the prices change in time.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you purchase a Premium Membership, it will automatically renew – and you will be charged – until you cancel it.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("After purchasing a subscription, it will begin its validity period immediately after the payment is confirmed by the payment processor.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("By placing an order, the User declares on their own responsibility and guarantees that they are over 18 years old and that they are a resident of the country from which they are placing the order and payment for the APP subscriptions.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("In the event that there are suspicions or complaints regarding the transactions you have made, your account will be blocked until the situation is clarified.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Owner does not guarantee that the service you paid for will be available immediately. We will do our best to ensure the proper functioning of the APP, but for various reasons – technical problems, internet connection issues – a service may be unavailable for a period of time. From the moment any issue is resolved, the respective service will be provided for the contracted period.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("REFUNDS")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("In accordance with the law, you are entitled to a full refund for 14 days after the start of your subscription. Please note that the 14-day period begins when the subscription begins. The withdrawal period will expire 14 days after purchasing the subscription. To exercise your right of withdrawal, you must inform the Owner of your decision to withdraw via email at: ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:groszvilmos@willandsons.com") {
                    org.jetbrains.compose.web.dom.Text("groszvilmos@willandsons.com")
                }
                org.jetbrains.compose.web.dom.Text(" . The Owner must analyze and make the refund in 14 days after he received the User’s email with full information about the User's name and bank account.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The User will need to provide a bank account where the value of the unused period of the subscription can be refunded.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("You will not receive a refund for the period during which you used the services associated with the purchased subscription!")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you are past the second automatic billing period, you are no longer entitled to the 14-day period for a refund of the subscription fee. If you wish to cancel your subscription, you will have access to the APP's features until the end of the period for which you have paid.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Additional costs incurred by the user when purchasing subscriptions, including but not limited to fees, rates, bank commissions, processing fees, if applicable, are not subject to any refund. These costs remain the sole responsibility of the user, regardless of the reason for requesting a refund of the subscription or service price.")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("By accepting the Terms and Conditions, the User agrees to the automatic renewal of payments through direct debit from the card account, and declares that the payment is made on their behalf and that they have the right to use the respective payment method. In the case of card payments, the User declares that they are over 18 years old and are the rightful cardholder. The Owner is not responsible for any claims related to the incorrect use or use by persons other than the cardholder of payment methods, for the depletion of users' payment resources, and cannot refund funds to the account if the user has made an incorrect purchase.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("END OF CONTRACT – CLOSING THE ACCOUNT")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you no longer want to use our services You can delete your account at any time by sending an email from the email associated with your account to ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:delete-account@lovenearby.willandsons.com") {
                    org.jetbrains.compose.web.dom.Text("delete-account@lovenearby.willandsons.com")
                }
                org.jetbrains.compose.web.dom.Text(". ")
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("If you have a renewing Premium Membership, you must cancel or manage any purchases of external services through your external service account (such as iTunes or Google Play) to avoid additional charges.")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Owner reserves the right to suspend or terminate your account without refund if you have violated these Terms or misused the Service.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("DISCLAIMER")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("The Owner provides the APP’s services “as is” and “as available”, but does not offer any kind of guarantee for:")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("the security of the APP's users")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("any errors, interruptions, or loss of connection")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("any dissatisfaction related to the appearance and functionality of the APP")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("ANY INFORMATION YOU RECEIVE ON OR THROUGH OUR SERVICES IS ACCURATE, COMPLETE, CURRENT, OR APPROPRIATE FOR YOUR PURPOSES.")
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("NO WARRANTIES FOR THE NUMBER OF ACTIVE USERS AT ANY GIVEN TIME, THE ABILITY OR DESIRE OF USERS TO COMMUNICATE WITH OR MEET WITH YOU, NOR ULTIMATELY THE COMPATIBILITY OR CONDUCT OF USERS YOU MEET THROUGH THE APP.")
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("COMPLAINTS")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("For resolving any complaints regarding the services offered by the Owner, contact the customer Support Team at the email address ")
                com.varabyte.kobweb.silk.components.navigation.Link("mailto:support@willandsons.com") {
                    org.jetbrains.compose.web.dom.Text("support@willandsons.com")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
        }
    }
}
